import React, { useCallback, useRef, useState } from "react";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { PipMascot, StarOutline, MotionLines } from "../../funnel/FunnelScreens";
import { StepHeading, ContinueButton, CtaRow, Item } from "../NOKit";

// iOS NOChildNameStep port: name + age on one screen. Both required.
// Pip points at the name field and cheers once a name is in it — the same
// mascot as the funnel's name step.
const AGES = ["3", "4", "5", "6", "7", "8", "9+"];

// A keyboard that pops up on its own is a jolt on a phone; on a desktop the
// cursor just lands in the field
const finePointer = () =>
  typeof window !== "undefined" && !!window.matchMedia?.("(pointer: fine)").matches;

const NameAgeStep = () => {
  const { username, setUsername, childAge, setChildAge, nextStep } = useOnboarding();
  const [name, setName] = useState(username || "");
  const queueCheer = useRef(() => {});
  const onPipReady = useCallback((fn) => {
    queueCheer.current = fn;
  }, []);

  const trimmed = name.trim();
  const canContinue = trimmed.length > 0 && !!childAge;

  const handleContinue = () => {
    if (!canContinue) return;
    setUsername(trimmed);
    nextStep();
  };

  return (
    <>
      <Item className="ob-mascot">
        <StarOutline className="fs-star ob-mascot-star-l" />
        <StarOutline className="fs-star ob-mascot-star-r" />
        <MotionLines className="fs-lines ob-mascot-lines" />
        <PipMascot cheer={trimmed.length > 0} onReady={onPipReady} />
      </Item>
      <StepHeading
        eyebrow="First, a name"
        title="Who's the"
        accent="star?"
        subtitle="A first name or nickname — every story will be about them."
      />

      <Item className="fs-field-wrap">
        <label className="fs-field">
          <span className="fs-field-label">First name or nickname</span>
          <input
            className="fs-field-input"
            type="text"
            value={name}
            maxLength={20}
            autoFocus={finePointer()}
            autoComplete="off"
            autoCapitalize="words"
            placeholder="e.g. Mia"
            onChange={(e) => {
              if (e.target.value.trim()) queueCheer.current();
              setName(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleContinue();
            }}
          />
        </label>
      </Item>

      <Item className="ob-section">
        <div className="ob-section-title">How old {trimmed ? `is ${trimmed}` : "are they"}?</div>
        <div className="ob-chips" role="radiogroup" aria-label="Age">
          {AGES.map((age) => (
            <button
              key={age}
              type="button"
              role="radio"
              aria-checked={childAge === age}
              className={`ob-chip${childAge === age ? " is-selected" : ""}`}
              onClick={() => setChildAge(age)}
            >
              {age}
            </button>
          ))}
        </div>
      </Item>

      <CtaRow>
        <ContinueButton onClick={handleContinue} disabled={!canContinue} />
      </CtaRow>
    </>
  );
};

export default NameAgeStep;
